import * as yup from 'yup'

const REQUIRED_FIELD_MSG = 'This field is required.'
const MIN_LENGTH = 'Password must be at least 6 characters.'
const INVALID_EMAIL = 'Invalid email format.'
export enum FIELDS {
  EMAIL = 'email',
  PASSWORD = 'password',
}

export const schema = yup
  .object({
    [FIELDS.EMAIL]: yup.string().trim().required(REQUIRED_FIELD_MSG).email(INVALID_EMAIL),
    [FIELDS.PASSWORD]: yup.string().trim().required(REQUIRED_FIELD_MSG).min(6, MIN_LENGTH),
  })
  .required()
